import React from "react";
import WorkDetailPageForDecisionManager from "./WorkDetailPageForDecisionManager";
import WorkDetailPageForRegularMember from "./WorkDetailPageForRegularMember";
import { useParams } from "react-router-dom";
import useDocumentDetailRedirect from "features/document/hooks/read/useDocumentDetailRedirect";

const DocumentWorkDetailPage = () => {
  const documentUuid = useParams().uuid as string;

  const { accessType } = useDocumentDetailRedirect({ documentUuid });

  if (accessType === "APPROVABLE") {
    return <WorkDetailPageForDecisionManager />;
  } else if (accessType === "READ_ONLY") {
    return <WorkDetailPageForRegularMember />;
  } else {
    return null;
  }
};

export default DocumentWorkDetailPage;
